import React, { memo, useState } from 'react'
import {
  ZoomableGroup,
  ComposableMap,
  Geographies,
  Geography
} from 'react-simple-maps'
import _ from 'lodash'
import * as world from '../world-50m.json'
import {
  europeCountriesIds,
  mainCountriesIds,
  countryData as data
} from '../mapData'
import { geoAzimuthalEqualArea } from 'd3-geo'
import { browserHistory } from 'react-router'
import './ToolkitComponent.scss'

const MapChart = ({ setTooltipContent, type }) => {
  const [selectedCountry, selectCountry] = useState('')

  const setColor = (value) => {
    if (value < -2) {
      return '#132262'
    } else if (value < -1) {
      return '#1B3683'
    } else if (value < 0) {
      return '#3661B7'
    } else if (value < 1) {
      return '#638CD3'
    } else if (value < 2) {
      return '#6FA5EA'
    } else {
      return '#A7D3FD'
    }
  }

  const colorLegend = [
    {
      name: '#A7D3FD',
      value: '3.0 – 2.1'
    },
    {
      name: '#6FA5EA',
      value: '2.0 – 1.1'
    },
    {
      name: '#3661B7',
      value: '1.0 – 0.1'
    },
    {
      name: '#3661B7',
      value: '-0.1 – -1.0'
    },
    {
      name: '#1B3683',
      value: '-1.1 – -2.0'
    },
    {
      name: '#132262',
      value: '-2.1 – -3.0'
    }
  ]

  this.colorCountry = (country) => {
    let countryData = {
      colorBase: '#00000040',
      colorHover: '#00000040',
      colorClicked: '#00000040',
      shouldClicked: false
    }
    selectedCountry
    ? countryData = {
      colorBase: '#112632',
      colorHover: '#112632',
      colorClicked: '#112632',
      shouldClicked: true
    }
    : europeCountriesIds.find(el => el === country.id)
    ? countryData = {
      colorBase: '#31313169',
      colorHover: '#31313169',
      colorClicked: '#31313169',
      shouldClicked: false
    } : mainCountriesIds.find(el => el === country.id) &&
    (countryData = {
      colorBase: setColor(_.find(data[type], { name: country.properties.name }).polarisation /
              _.find(data[type], { name: country.properties.name }).resilience),
      colorHover: setColor(data[type][country.properties.name]),
      colorClicked: setColor(data[type][country.properties.name]),
      shouldClicked: true
    })
    return countryData
  }

const projection = (width, height, config) => {
    return geoAzimuthalEqualArea()
      .rotate([-10, -52, 0])
  }

  return (
    <React.Fragment>
      <ComposableMap
      projectionConfig={{
        scale: 700
      }}
      data-tip=''
      width={880}
      height={451}
      style={{
        width: '100%',
        height: 'auto'
      }}
      >
        <ZoomableGroup center={[20, 50]} disablePanning>
          <Geographies geography={world}>
            {({ geographies }) => geographies.map((geography, i) => (
              <a href={`${window.location.href}/${type}/${geography.properties.name}`}
                target='_blank' key={i}>
                <Geography
                geography={geography}
                projection={projection}
                onMouseEnter={() => {
                    setTooltipContent(`${geography.properties.name}`)
                  }}
                  onMouseLeave={() => {
                    setTooltipContent('')
                  }}
                style={{
                  default: {
                    fill: this.colorCountry(geography).colorBase,
                    stroke: 'white',
                    strokeWidth: 1.75,
                    outline: 'none'
                  },
                  hover: {
                    fill: this.colorCountry(geography).colorHover,
                    stroke: 'white',
                    strokeWidth: 1.75,
                    outline: 'none'
                  },
                  pressed: {
                    fill: this.colorCountry(geography).colorClicked,
                    stroke: 'white',
                    strokeWidth: 1.75,
                    outline: 'none'
                  }
                }}
              />
              </a>
            ))}
          </Geographies>
        </ZoomableGroup>
      </ComposableMap>
      <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%', justifyContent: 'space-around' }}>
        {colorLegend.map((color, i) =>
          <div key={i} style={{ display: 'flex', alignItems: 'center' }}>
            <div className='box-legend' style={{ backgroundColor: color.name }}/>
            <div>
              {color.value}
            </div>
          </div>)}
      </div>
    </React.Fragment>
  )
}

export default memo(MapChart)



// WEBPACK FOOTER //
// ./src/components/ToolkitComponent/components/Map.js